import { useState } from 'react';
import Dropdowns from '../../../../components/Dropdowns/Dropdowns';
import { Expandable2 } from '../../../../components/Expandable/Expandable2';
import './Boxes.scss';
import { ImageWithButtons } from './ImageWithButtons';
import { FileUploader } from '../../../../components/FileUploader/FileUploader';
import { addBox, boxChange, saveBox, selectAwbIds, selectBoxes } from '../../../../redux/features/StoresModule/packageIntakeSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useDropdownConfig } from '../../../../contexts/DropdownsContext';
import { HTTP_RESPONSE_CODES } from '../../../../globals/globals';
import { useSnackBar } from '../../../../hooks/useSnackBar';
let mockBoxes = [{
    id: 0,
    condition: "crushed",
    photos: []
}]
export const Boxes = ({ awb }) => {
    const boxCondition = useDropdownConfig(128);
    // const [files, setFiles] = useState([]);
    // const [boxes, setBoxes] = useState([]);
    const allBoxes = useSelector(selectBoxes);
    const boxes = allBoxes[awb];
    const dispatch = useDispatch();
    const awbIds = useSelector(selectAwbIds);
    const { successMsg } = useSnackBar();

    const onUpload = ({ awb, idx, e, prevVal }) => {
        const files = Array.from(e.target.files);
        const newImageURLs = files.map((file) => {
            return {
                file,
                preview: URL.createObjectURL(file),
            };
        });
        console.warn('onupload params', awb, idx, e, prevVal);
        dispatch(boxChange({ awb, idx, name: "imageFiles", value: [...prevVal, ...newImageURLs] }))

        // setFiles((prev) => [...prev, ...newImageURLs]);
    }

    const saveCall = (awb, awbId, idx, box) => {
        dispatch(saveBox({ awb, awbId, idx, box })).then(action => {
            let { respData } = action.payload;

            console.warn('response save box', respData);
            if (respData.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
                successMsg("Box Saved");
            }
        })
    }

    return (
        <div className="boxes-component">
            <div className="box-header">
                <b>Box(es) Associated</b>
                {Boolean(awb) ? <button onClick={() => dispatch(addBox({ awb, awbId: awbIds[awb] }))} className="filled mid-size">
                    + Add Box

                </button> : <span className='info-btn'><i className='icon-info'></i> <i>Select an AWB number to add boxes</i> </span>}


            </div>
            <div className="boxes-list">

                {boxes?.length > 0 ? boxes.map((b, i) =>
                    <Expandable2 key={b.tempId} summary={
                        <div className="box" style={{ position: "relative" }}>
                            {/* <i style={{ position: "absolute", fontSize: "0.4rem", top: "-0.2rem" }}>{JSON.stringify(b)}</i> */}
                            <b>BOX {i + 1}</b>
                            <div className="drpdwn">
                                <span className="label"></span>
                                <Dropdowns preSelectValue={b.condition} onOptionSelect={(e) => dispatch(boxChange({ awb, idx: i, name: "condition", value: e.id }))} optionLabel="name" selectionLabel="name" hideLabel data={boxCondition.config} />
                                <div className='boxactions'>

                                    <div className='boxbtn camerabutton'>
                                        <i className='icon-add-photo'></i>
                                    </div>
                                    <div className='boxbtn'>
                                        <i className='icon-delete-new'></i>
                                    </div>
                                </div>

                            </div>
                        </div>
                    }>

                        <div className='photos-container'>
                            <div className='ph-header'>
                                <div className='title'>

                                    <i className='icon-add-photo'></i>
                                    <b>Attached Image</b>

                                    <b className='boxnumber'>- Box {i + 1}</b>
                                </div>
                                <div className='actions'>
                                    <button className='filled mid-size' onClick={() => saveCall(awb, awbIds[awb], i, b)}>Save</button>
                                    <button className='outline mid-size icon'><i className='icon-cross'></i></button>

                                </div>
                            </div>
                            {/* {JSON.stringify(b.imageFiles?.map(i => ({...i, preview: i.preview.slice(0, 30)})))} */}
                            <div className='ph-content'>
                                {/* <div className='drop-area'>
                                    Upload Evidence Photo
                                </div> */}
                                <FileUploader label="Upload Evidence Photos" onUpload={(e) => onUpload({ awb, idx: i, e, prevVal: (b.imageFiles ?? []) })} accept="image/*" multiple capture="environment">
                                    <div className='boxbtn'>
                                        <i className='icon-add-photo'></i>
                                    </div>
                                </FileUploader>
                                <FileUploader label="Upload Evidence Photos" onUpload={(e) => onUpload({ awb, idx: i, e, prevVal: (b.imageFiles ?? []) })} accept="image/*" multiple />

                            </div>

                            {b.imageFiles?.length > 0 && <div className='filearray'>
                                {b.imageFiles.map((img, index) => (

                                    <ImageWithButtons
                                        key={index}
                                        src={img.preview}
                                        alt={`upload-${index}`}
                                        onDelete={() => dispatch(boxChange({ awb, idx: i, name: "imageFiles", value: b.imageFiles.filter((_, j) => !(j === i)) }))}
                                        caption={img.file.name}
                                    />
                                ))}
                            </div>}
                            {/* {files?.length > 0 && <div className='filearray'>
                                {files.map((img, index) => (
                                   
                                    <ImageWithButtons
                                        key={index}
                                        src={img.preview}
                                        alt={`upload-${index}`}
                                        onDelete={() => setFiles(prev => prev.filter((i, j) => !(j === index)))}
                                        caption={img.file.name}
                                    />
                                ))}
                            </div>} */}


                        </div>

                    </Expandable2>
                ) :
                    <div className='placeholder-component'>
                        <i>No boxes created</i>
                    </div>
                }

            </div>

        </div>
    )

}